module.exports = __webpack_public_path__ + "img/JalilKakaWais-Rawasebar.697c479c.jpg";